import { useInvoiceTemplatesQuery } from "../../query/payments/queries";
import { getInvoiceTemplates } from "../../query/payments/selectors";
import { DownloadInvoicesCSV } from "./DownloadInvoicesCSV";
import { InvoicesTable } from "./InvoicesTable";

export const TableInvoicesScheduled: React.FC = () => {
  const queryInvoiceTemplates = useInvoiceTemplatesQuery();

  const invoiceTemplates = getInvoiceTemplates(
    queryInvoiceTemplates.data || []
  );

  return (
    <InvoicesTable
      mt="2XL"
      title="Scheduled"
      invoiceTemplates={invoiceTemplates}
      actions={
        <DownloadInvoicesCSV
          invoiceTemplates={invoiceTemplates}
          isDataReady={queryInvoiceTemplates.status === "success"}
        />
      }
    />
  );
};
